import { Box, Heading } from '@chakra-ui/react'

const NotData = () => {
	return (
		<Box
			w='full'
			h='60vh'
			display='flex'
			justifyContent='center'
			alignItems='center'
		>
			<Heading
				as='h2'
				fontSize={{ base: 'lg', md: 'xl' }}
				color='gray.600'
				fontWeight='700'
			>
				No hay datos
			</Heading>
		</Box>
	)
}

export default NotData
